import * as Sentry from "@sentry/react";
import { LogErrors } from "./LogErrors";
export const fetchIncidentNotes = async (incidentId, token) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}Incident/FetchIncidentNotes?IncidentId=${incidentId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorMsg = `Failed to fetch incident notes. Status: ${response.status} - ${response.statusText}`;
      Sentry.captureMessage(errorMsg, "error");
      // LogErrors(user, logout, updateTokens, errorMsg);
      return null;
    }

    return await response.json();

  } catch (error) {
    // LogErrors(user, logout, updateTokens, "Error fetching incident notes:", error);
    Sentry.captureException(error);
    return null;
  }
};